import React from "react";

export const Logo = ({ inverse = false, compact = false }) => {
  const src = inverse ? "/brand/agartha-logo-white.png" : "/brand/agartha-logo.png";
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img
        src={src}
        alt="AGARTHA CONSTRUCTION"
        style={{ height: compact ? 32 : 44, width: "auto", display: "block" }}
        draggable="false"
      />
    </div>
  );
};
